import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getTapestryCombo from '../../services/tapestry/getTapestryCombo'

export function * fetchTapestryCombo ({ catalogueId, modelId }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const tapestryCombo = yield call(getTapestryCombo, auth.token, catalogueId, modelId)
    yield put(fetchCombosSuccess({ tapestryCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchTapestryCombo () {
  yield takeLatest(combosActionTypes.FETCH_TAPESTRY_COMBO, fetchTapestryCombo)
}
